/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Distillation_Error_Already_In_ProgressInputs */



/**
* | output |
* | --- |
* | "A request is already in progress for this chat" |
*
* @param {Distillation_Error_Already_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const distillation_error_already_in_progress = /** @type {((inputs?: Distillation_Error_Already_In_ProgressInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Distillation_Error_Already_In_ProgressInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Anfrage ist bereits für diesen Chat aktiv")
	return /** @type {LocalizedString} */ ("A request is already in progress for this chat")
});